module.exports = __webpack_public_path__ + "img/odnnary-red-scheme.56b2e0c7.jpg";